import React from 'react'
import { observer } from 'mobx-react'
import NoData from 'components/NoData'
import './styles.sass'

const BrokerPicker = ({ provider }) => (
  <div className="broker-picker">
    <div className="top-bar">
      <div className="searchfield-container">
        <input
          type="search"
          className="searchfield"
          placeholder="Type here to search for your institution"
          value={provider.searchText}
          onChange={e => provider.setSearchText(e.target.value)}
        />
      </div>
    </div>
    {provider.filteredBrokerages.length === 0
      ? (
        <NoData icon="search" theme="blue">
          No brokerages matched your filter.
        </NoData>
      )
      : (
        <div className="brokerages">
          {provider.filteredBrokerages.map((brokerage) =>
            <Brokerage
              key={brokerage.id}
              brokerage={brokerage}
              onClick={() => provider.selectBrokerage(brokerage)}
            />
          )}
        </div>
      )
    }
  </div>
)

export default observer(BrokerPicker)

let Brokerage = ({ brokerage, onClick }) => (
  <div className="brokerage">
    <button className="brokerage-button" onClick={onClick}>
      {brokerage.logo
        ? <img src={brokerage.logo} className="brokerage-logo" alt={brokerage.name} />
        : brokerage.name
      }
    </button>
  </div>
)

Brokerage = observer(Brokerage)



// WEBPACK FOOTER //
// ./src/client/components/LinkAccountDialog/QuovoProvider/BrokerPicker/index.jsx